
<template>
  <div>
    <list
      row-key="DeviceId"
      ref="list"
      unit="考勤设备"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
      form-label-width="100px"
    >
      <template slot="toolbar-right">
        <!-- <el-button size="small" class="filter-item" @click="onExport" type="primary" plain>导出</el-button> -->
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="考点">
          <el-input v-model="params.ExamPlace" placeholder="请输入考点" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="ExamPlace" label="考点" />
        <el-table-column prop="StudentNumber" label="人数" />
        <el-table-column prop="Note" label="注意事项" show-overflow-tooltip min-width="200" />
        <el-table-column prop="Status" label="状态" width="80" align="center">
          <template slot-scope="{row}">
            <el-tag type="danger" v-if="row.Status == 0">停用</el-tag>
            <el-tag type="success" v-else>启用</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/po/exam").default,
      params: {
        ExamPlace: "",
        EnrollType: null,
        Status: null,
      },
    };
  },
  methods: {
    onExport() {
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>